export const train_logo = require("./assets/logo192.png");
export const the_lunch_train = require("./assets/the-lunch-train.png");